import { GROUP_FLOW_STEPS } from '../constants';
import { StepProgressBar } from '../styles';

const StepProgress = ({ currentStepId }) => {
  const currentIndex = GROUP_FLOW_STEPS.findIndex((s) => s.id === currentStepId);
  const current = GROUP_FLOW_STEPS[currentIndex] || GROUP_FLOW_STEPS[0];

  return (
    <StepProgressBar>
      <div className="step-meta">
        <span className="step-label">
          {currentIndex + 1}. {current.label}
        </span>
        <span className="step-count">
          Paso {currentIndex + 1} de {GROUP_FLOW_STEPS.length}
        </span>
      </div>
      <div className="step-bars">
        {GROUP_FLOW_STEPS.map((step, index) => (
          <div
            key={step.id}
            className={`step-bar ${index < currentIndex ? 'active' : ''} ${
              index === currentIndex ? 'current' : ''
            }`}
          />
        ))}
      </div>
    </StepProgressBar>
  );
};

export default StepProgress;
